import axios from 'axios'

const WP_URL = `${process.env.WP_URL}wp-json/pixels-headless/v1/offerrequest`
const SECRET = process.env.HEADLESS_SECRET

/**
 * Local API endpoint: get user offers
 */
export const getUserOfferRequests = async (userEmail) => {
  const result = await axios({
    method: 'get',
    url: `/api/offers/${userEmail}`,
  })

  return result.data
}

/**
 * WP API: get user offers.
 * Called from server side, can include WP secret.
 */
export const getUserOfferRequestsFromWP = async (user) => {
  const result = await axios({
    method: 'get',
    url: `${WP_URL}?secret=${SECRET}&login=${user}`,
  })

  return result
}

export default {
  getUserOfferRequests,
  getUserOfferRequestsFromWP,
}
